import { Meteor } from 'meteor/meteor';
import rateLimit from '../../modules/rate-limit';

import {
  fetchOne,
  insert,
  update,
  softDelete,
  restore,
  hardDelete,
  getTaskList,
  runTask,
  runTask2,
  getTaskMonitor,
  getTaskResults,
  updateTaskLabel,
  cancel,
  pause,
  resume,
  getAIEntitiesList,
  getFocusedTrainParamsList,
  checkAtlasTaskName,
  getTaskFTPParameters,
  getDataSet,
  getListJson
} from './server/task-methods-server';

Meteor.methods({
  'tasks.fetchOne'(taskId) {
    return fetchOne(taskId);
  },
  'tasks.insert'(argument) {
    return insert(argument);
  },
  'tasks.update'(task) {
    return update(task);
  },
  'tasks.softDelete'(taskId) {
    softDelete(taskId);
  },
  'tasks.restore'(taskId) {
    restore(taskId);
  },
  'tasks.hardDelete'(taskId) {
    return hardDelete(taskId);
  },
  'tasks.getTasklist'(debugIP) {
    return getTaskList(debugIP);
  },
  'tasks.runTask'(argument) {
    return runTask(argument);
  },
  'tasks.runTask2'(argument) {
    return runTask2(argument);
  },
  'tasks.getDataset'(argument) {
    return getDataSet(argument);
  },
  'tasks.getListJson'(argument) {
    return getListJson(argument);
  },
  'tasks.getTaskMonitor'(argument) {
    return getTaskMonitor(argument);
  },
  'tasks.getTaskResults'(debugIP) {
    return getTaskResults(debugIP);
  },
  'tasks.updateTaskLabel'(taskId, newLabel) {
    return updateTaskLabel(taskId, newLabel);
  },
  'tasks.cancel'(taskId, newLabel) {
    return cancel(taskId, newLabel);
  },
  'tasks.pause'(taskId, newLabel) {
    return pause(taskId, newLabel);
  },
  'tasks.resume'(taskId, newLabel) {
    return resume(taskId, newLabel);
  },
  'tasks.getAIEntitiesList'(debugIP) {
    return getAIEntitiesList(debugIP);
  },
  'tasks.getFocusedTrainParamsList'(debugIP) {
    return getFocusedTrainParamsList(debugIP);
  },
  'tasks.checkAtlasTaskName'(argument) {
    return checkAtlasTaskName(argument);
  },
  'tasks.getTaskFTPParameters'() {
    return getTaskFTPParameters();
  }
});

rateLimit({
  methods: [
    'tasks.fetchOne',
    'tasks.insert',
    'tasks.update',
    'tasks.softDelete',
    'tasks.restore',
    'tasks.hardDelete',
    'tasks.getTasklist',
    'tasks.runTask',
    'tasks.runTask2',
    'tasks.getTaskResults',
    'tasks.updateTaskLabel',
    'tasks.cancel',
    'tasks.pause',
    'tasks.resume',
    'tasks.getDataset',
    'tasks.getListJson'
  ],
  limit: 5,
  timeRange: 1000
});
